<!-- Here is where the component card is defined based on configuration and templates -->
<mat-card>
    <mat-card-content>
        <form (ngSubmit)='persistData()'>
            <!-- Horizontal Stepper -->
            <mat-horizontal-stepper *ngIf="!isVertical && !isEmbed" labelPosition='bottom'
                [linear]='0 !== (serviceDefinitions?.inOrder ?? 0)' [selectedIndex]='selected'
                (selectionChange)="setStep($event)">
                <ng-template matStepperIcon="number" let-index="index">
                    <mat-icon [matBadge]="getCartCount()" [matBadgeHidden]="index != stepDefinitions.length - 1">
                        {{stepDefinitions[index].icon}}</mat-icon>
                </ng-template>
                <ng-template matStepperIcon="edit" let-index="index">
                    <mat-icon [matBadge]="getCartCount()" [matBadgeHidden]="index != stepDefinitions.length - 1">
                        {{stepDefinitions[index].icon}}</mat-icon>
                </ng-template>
                <ng-template matStepperIcon="error" let-index="index">
                    <mat-icon [matBadge]="getCartCount()" [matBadgeHidden]="index != stepDefinitions.length - 1">
                        {{stepDefinitions[index].icon}}</mat-icon>
                </ng-template>
                <ng-template matStepperIcon="done" let-index="index">
                    <mat-icon [matBadge]="getCartCount()" [matBadgeHidden]="index != stepDefinitions.length - 1">
                        {{stepDefinitions[index].icon}}</mat-icon>
                </ng-template>
                <ng-template matStepperIcon="stepDefinitions[index].step" let-index="index">
                    <mat-icon [matBadge]="getCartCount()" [matBadgeHidden]="index != stepDefinitions.length - 1">
                        {{stepDefinitions[index].icon}}</mat-icon>
                </ng-template>
                <ng-container *ngFor="let step of stepDefinitions; let index = index; let last = last;">
                    <mat-step state='{{step.step}}' *ngIf="isStepVisible(step)" [optional]='isOptional(step)'>
                        <ng-template matStepLabel>
                            <span>{{step.label}}</span>
                        </ng-template>
                        <mutara-form [index]='index' [stepDefinitions]='stepDefinitions' [submitText]='serviceDefinitions.nextStep'>
                        </mutara-form>
                    </mat-step>
                </ng-container>
            </mat-horizontal-stepper>

            <!-- Vertical Stepper (mobile) -->
            <mat-vertical-stepper *ngIf="isVertical && !isEmbed" [linear]='0 !== (serviceDefinitions?.inOrder ?? 0)'
                [selectedIndex]='selected'>
                <ng-template matStepperIcon="number" let-index="index">
                    <mat-icon [matBadge]="getCartCount()" [matBadgeHidden]="index != stepDefinitions.length - 1">
                        {{stepDefinitions[index].icon}}</mat-icon>
                </ng-template>
                <ng-template matStepperIcon="edit" let-index="index">
                    <mat-icon [matBadge]="getCartCount()" [matBadgeHidden]="index != stepDefinitions.length - 1">
                        {{stepDefinitions[index].icon}}</mat-icon>
                </ng-template>
                <ng-template matStepperIcon="error" let-index="index">
                    <mat-icon [matBadge]="getCartCount()" [matBadgeHidden]="index != stepDefinitions.length - 1">
                        {{stepDefinitions[index].icon}}</mat-icon>
                </ng-template>
                <ng-template matStepperIcon="done" let-index="index">
                    <mat-icon [matBadge]="getCartCount()" [matBadgeHidden]="index != stepDefinitions.length - 1">
                        {{stepDefinitions[index].icon}}</mat-icon>
                </ng-template>
                <ng-template matStepperIcon="stepDefinitions[index].step" let-index="index">
                    <mat-icon [matBadge]="getCartCount()" [matBadgeHidden]="index != stepDefinitions.length - 1">
                        {{stepDefinitions[index].icon}}</mat-icon>
                </ng-template>
                <ng-container *ngFor="let step of stepDefinitions; let index = index; let last =last ;">
                    <ng-template matStepperIcon={{step.icon}}>
                        <mat-icon>{{step.icon}}</mat-icon>
                    </ng-template>
                    <mat-step state='{{step.step}}' *ngIf="isStepVisible(step)" (click)="setStep(index)">
                        <ng-template matStepLabel>
                            <span>{{step.label}}</span>
                        </ng-template>
                        <mutara-form [domForm]='formGroup.at(index)' [formDataComplete]='formModel' [index]='index'
                            [stepDefinitions]='stepDefinitions' [submitText]='serviceDefinitions.nextStep'>
                        </mutara-form>
                    </mat-step>
                </ng-container>

            </mat-vertical-stepper>
            <!-- "Stepper" but with supressed steps other than first (index 0) when embedded -->
            <mat-horizontal-stepper *ngIf=!!isEmbed>
                <ng-container *ngFor="let step of stepDefinitions; let index = index;">
                    <p>{{index}}</p>
                    <mat-step state='{{step.step}}'>
                        <mutara-form [index]='index' [domForm]='formGroup.at(index)' [formDataComplete]='formModel'
                            [stepDefinitions]='stepDefinitions' [submitText]='serviceDefinitions.nextStep'>
                        </mutara-form>
                    </mat-step>
                </ng-container>
            </mat-horizontal-stepper>

        </form>
    </mat-card-content>
</mat-card>